import { Injectable } from '@angular/core';
import { Pad } from '../utils/pad';

@Injectable({
    providedIn: 'root'
})
export class DateTimeService {

    constructor() { }

    public formatDateTime = 'dd-MM-yyyy HH:mm:ss';
    public formatDate = 'dd-MM-yyyy';
    public formatTime = 'HH:mm'

    public setDateFormat(dateFormat: string) {
        this.formatDate = dateFormat;
    }

    public setDateTimeFormat(dateTimeFormat: string) {
        this.formatDateTime = dateTimeFormat;
    }

    public getDevExpressDateFormat() {
        return {
            type: 'longDate'
        };
    }

    public getDevExpressDateTimeFormat() {
        return {
            //skeleton: this.formatDateTime
            type: 'shortDateShortTime'
        };
    }

    public getFormattedTime(value: Date) {
        //if its not a date object create one
        if (!(value instanceof Date)) {
            value = new Date(value);
        }

        let result = '';

        let hours = value.getHours().toString();
        hours = parseInt(hours) < 10 ? '0' + hours : hours;

        let mins = value.getMinutes().toString();
        mins = parseInt(mins) < 10 ? '0' + mins : mins;

        let sec = value.getSeconds().toString();
        sec = parseInt(sec) < 10 ? '0' + sec : sec;

        result = hours + ':' + mins + ':' + sec;
        return result;
    }

    private getFormattedDate(value: Date, includeTime: boolean = true) {
        const result = '';
        const year = value.getFullYear();
        let month = (value.getMonth() + 1).toString();
        month = parseInt(month) < 10 ? '0' + month.toString() : month;
        let day = value.getDate().toString();
        day = parseInt(day) < 10 ? '0' + day : day;

        const date = year + '-' + month + '-' + day;

        if (!includeTime) {
            return date;
        }

        const time = this.getFormattedTime(value);

        return date + ' ' + time;
    }

    public getDevExpressDateTimeWithMsFunction(value: Date) {
        //if its not a date object create one
        if (!(value instanceof Date)) {
            value = new Date(value);
        }
        // the "this" keyword not working because devexpress is calling it from a non-arrow function
        let dateString = new DateTimeService().getFormattedDate(value); // Milliseconds not supported: https://github.com/angular/angular/issues/7590
        dateString += '.' + Pad.padLeft(value.getMilliseconds(), 3);
        return dateString;
    }

    public getDevExpressDateTimeFunction(value: Date) {
        //if its not a date object create one
        if (!(value instanceof Date)) {
            value = new Date(value);
        }
        //var test = Object.prototype.toString.call(value) === '[object Date]'
        // the "this" keyword not working because devexpress is calling it from a non-arrow function
        const result = new DateTimeService().getFormattedDate(value);
        return result;
    }


    public getDevExpressDateFunction(value: Date) {
        //if its not a date object create one
        if (!(value instanceof Date)) {
            value = new Date(value);
        }
        // the "this" keyword not working because devexpress is calling it from a non-arrow function
        return new DateTimeService().getFormattedDate(value, false);
    }

    public setTimeSpan(type: string, dateTo: Date, dateFrom: Date): DatePeriod {
        // Create new date-instances to prevent the original from being modified...
        dateTo = new Date(dateTo);
        dateFrom = new Date(dateFrom);
        const currentWeekDay = dateFrom.getDay();

        switch (type) {
            case 'today':
                dateFrom = new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());
                dateTo = undefined;
                break;
            case 'yesterday':
                dateFrom.setDate(dateFrom.getDate() - 1);
                break;
            case 'thisweek':
                dateFrom.setDate(dateFrom.getDate() - currentWeekDay + 1); // +1 to get monday
                dateTo = undefined;
                break;
            case 'lastweek':
                dateTo.setDate(dateTo.getDate() - currentWeekDay + 1); // +1 to get monday
                dateFrom.setDate(dateFrom.getDate() - currentWeekDay - 6); // -6 because sunday = 0
                break;
            case 'thismonth':
                dateFrom.setDate(1);
                dateTo = undefined;
                break;
            case 'lastmonth':
                dateTo.setDate(1);
                dateFrom.setDate(1);
                dateFrom.setMonth(dateFrom.getMonth() - 1);
                break;
            case 'last7days':
                dateFrom.setDate(dateFrom.getDate() - 7);
                dateTo = undefined;
                break;
            case 'last30days':
                dateFrom.setDate(dateFrom.getDate() - 30);
                dateTo = undefined;
                break;

        }

        return new DatePeriod(dateFrom, dateTo);
    }
}

export class DatePeriod {
    constructor(public start: Date, public end: Date) { }
}
